import { render, staticRenderFns } from "./iconCopySuggestion.vue?vue&type=template&id=f9921d76&scoped=true"
import script from "./iconCopySuggestion.vue?vue&type=script&lang=js"
export * from "./iconCopySuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9921d76",
  null
  
)

export default component.exports